import React, {useState} from "react";
import PropTypes from "prop-types";
import {Link, useLocation} from "react-router-dom";
import { useSelector } from "react-redux";
import {Button, Drawer, Icon, Menu} from "antd";

import NavMainMenu from "./NavMainMenu";
import UserNavComponent from "./UserNavComponent";
import NavLanguage from "./NavLanguage";
import NavTitle from './NavTitle';
import MobileAvatar from "./MobileAvatar";
import AvatarS4u from 'assets/img/AvatarS4u.png'

import { setIcon } from "../../services/setIcon";
import { IconComponent } from "components/common/IconComponent";
import logo from "assets/img/sandos/logo.png";
import new_logo from "assets/img/sandos/new_logo.png";
import { getLanguage } from '../../selectors/global';

import './style.scss';
import { register } from "serviceWorker";
import RegisterPage from "pages/Register";


const AppNavComponent = ({ history, brandDetails, dispatch, setActivePath }, context) => {
  const [visible, setVisible] = useState(false);
  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);
  const member = useSelector((state) => state.authentication.loy3Profile);
  const membershipInfo = useSelector((state) => state.sandos4U.membershipUser);
  const titleId = useSelector((state) => state.global.titleId);
  const brandConstants = useSelector((state) => state.global.brandConstants);
  const lang = useSelector(getLanguage);
  const brandName = brandDetails?.brandName || '';
  const location = useLocation()
  document.addEventListener('closeNavMenu', () => {
    onClose();
  });
  const closeNavMenu = () => document.dispatchEvent(new CustomEvent('closeNavMenu'));
  return (
    <>
    {!member && location.pathname === '/' &&(
      <>
        <div class="hero relative text-white flex">
          <img src="./img/main-img-new-landing-S4U.png" class="absolute object-cover inset-0 w-full h-full opacity-75" />
          <p>&nbsp;</p>
        </div>
      </>
    )}

    {member && (
      <header className="main-header fixed z-50 inset-x-0 flex justify-between">
        <div 
          className="container header-container mx-auto w-full flex justify-between items-center"
        >
        <div className="m-2">
            <a href="https://www.sandos.com/" target="_blank" rel="noopener noreferrer">
            <img
              src={new_logo}
              alt="logo"
              style={{
                width: "180px",
                height: "auto",
                paddingRight: "30px",
              }}
            />
            </a>
        </div>
          {/* <NavTitle titleId={titleId} lang={lang} history={history} /> */}
          <MobileAvatar src={member?.profilePic || AvatarS4u} />
          <NavMainMenu
            dispatch={dispatch}
            member={member}
            brandConstants={brandConstants}
            lang={lang}
            className="customMenuDisplay"
            closeNavMenu={closeNavMenu}
          />
          <div className="flex items-center gap-1 hidden md:flex">
            <UserNavComponent
              member={member}
              membershipInfo={membershipInfo}
              brandName={brandName}
              dispatch={dispatch}
              closeNavMenu={closeNavMenu}
            />
            <NavLanguage
              mode="horizontal"
              className="hidden md:flex ml-6 text-sm"
              closeNavMenu={closeNavMenu}
            />
          </div>
          <Button
            className="text-white transform rotate-90 customMenuDisplayInverted my-auto"
            type="link"
            onClick={showDrawer}
            icon="pause"
            size="large"
          />
          <Drawer
            title="Menu"
            placement="right"
            onClose={onClose}
            visible={visible}
            className="nav-mobile"
          >
            <NavMainMenu
              className="mobile"
              dispatch={dispatch}
              member={member}
              brandConstants={brandConstants}
              lang={lang}
              closeNavMenu={closeNavMenu}
            />
            <UserNavComponent
              member={member}
              membershipInfo={membershipInfo}
              brandName={brandName}
              dispatch={dispatch}
              closeNavMenu={closeNavMenu}
            />
            <NavLanguage
              mode="inline"
              type="mobile"
              dispatch={dispatch}
              member={member}
              brandConstants={brandConstants}
              closeNavMenu={closeNavMenu}
            />
              <Menu mode="inline" className="logout-overpower">
                <Menu.Item>
                  <Link
                    to="/logout"
                    onClick={closeNavMenu}
                  >
                    {context.t("Log out")}
                    <Icon component={setIcon("logout")}/>
                  </Link>
                </Menu.Item>
              </Menu>
          </Drawer>
        </div>
      </header>
    )}
    </>
  );
};


AppNavComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AppNavComponent;
